<div class="mb-4">
  <app-target-limit-warning [targetLimit]="targetLimit()" />
</div>
<div *transloco="let t">
  @if (strategy(); as strategy) {
    <div class="flex flex-col gap-2">
      <div data-testid="tactic-list">
        @if (strategy.tactics) {
          @for (tactic of strategy.tactics; track tactic) {
            <app-tactic
              [tactic]="tactic"
              [strategy]="strategy"
              [showKW]="strategy.campaignType !== CampaignType.SD"
              [showProducts]="!productSegmentDisabled() || tactic.tacticType === 'BLACKLIST'"
              [isReadOnly]="isReadOnly()"
            ></app-tactic>
          }
        }
      </div>
      @if (strategy.tactics.length === 0) {
        <p class="default-message">
          {{ t("strategy-page.no_tactic") }}
        </p>
      }
      <button iButton variant="secondary" [disabled]="isReadOnly()" testId="btn-add-tactic" (click)="createTactic()">
        <IIcon name="plus" />
        {{ t("strategy-page.add_a_tactic") }}
      </button>
    </div>
  }
</div>
